/**
 * 时间图标
 */
const TimeIcon = ({ color = '#6e6e73 ' }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 4V8H11.3333" stroke={color} strokeWidth="1.33333" />
      <circle cx="8" cy="8" r="6" stroke={color} strokeWidth="1.33333" />
    </svg>
  )
}

export default TimeIcon
